import { Injectable } from '@angular/core';
import { Subject, switchMap } from 'rxjs';
import { Store } from '@ngxs/store';
import { CargoRepositoryService } from '@shared/services/cargo-repository.service';
import { PaymentRepositoryService } from '@shared/services/payment-repository.service';
import {
  SetOrders,
  SetPayments,
  SetSelectedCargo,
  UpdateOrder,
  UpdatePayment,
} from '../store/cargo-calculation.actions';
import { Cargo, CargoOrder } from '../../../types/cargo';
import { Payment } from '../../../types/payment';

@Injectable()
export class CargoCalculationService {
  saveRecalculatedValues$ = new Subject<void>();
  constructor(
    private readonly store: Store,
    private readonly cargoRepository: CargoRepositoryService,
    private readonly paymentRepository: PaymentRepositoryService,
  ) {}

  getCargoById(id: number) {
    return this.cargoRepository.getCargoById(id);
  }

  setSelectedCargo(id: number) {
    return this.getCargoById(id).pipe(
      switchMap(payload => this.store.dispatch(new SetSelectedCargo(payload))),
    );
  }

  updateCargo(cargo: Cargo) {
    return this.cargoRepository
      .updateCargo(cargo)
      .pipe(
        switchMap(updatedCargo =>
          this.store.dispatch(new SetSelectedCargo(updatedCargo)),
        ),
      );
  }

  updateOrder(order: CargoOrder) {
    return this.cargoRepository
      .updateOrder(order)
      .pipe(switchMap(order => this.store.dispatch(new UpdateOrder(order))));
  }

  sendCalculatedCargoTo1c(id: number) {
    return this.cargoRepository.sendCalculatedCargoTo1c(id);
  }

  calculate(id: number) {
    return this.paymentRepository
      .calculate(id)
      .pipe(
        switchMap(payments => this.store.dispatch(new SetPayments(payments))),
      );
  }

  savePayment(payment: Payment) {
    return this.paymentRepository
      .save(payment)
      .pipe(
        switchMap(payment => this.store.dispatch(new UpdatePayment(payment))),
      );
  }

  fetchOrdersByCargoId(id: number) {
    return this.cargoRepository
      .getOrdersByCargoId(id)
      .pipe(switchMap(orders => this.store.dispatch(new SetOrders(orders))));
  }
}
